import {prompt} from '@scoutgg/ftw/source/services/modal';

async function checkDuplicateNames(players) {
  const tally = players.reduce((obj, player) => {
    const key = (player.lastName || player.customName || '???').toLowerCase()
    if(!obj[key]) {
      obj[key] = 1
    } else {
      obj[key]++
    }
    return obj
  }, {})

  const duplicates = Object.entries(tally)
    .filter(([name, count]) => count > 1)
    .map(([name, count]) => name.toUpperCase())
    .join(', ')

  if(!duplicates.length) return
  return prompt(`The team(s) of your lineup player(s) ${duplicates} have players with the same last name.
    Are you sure you have the correct players on lineups?`, { type: 'yesno' })
}

export default checkDuplicateNames;
